






























































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import SummerNote from '@/components/common/summernote/Index.vue';
import {popupResize} from '@/utils/ncp';
import {changeDateFormat} from '@/utils/dateUtils';
import {PostContractsEntryContractsRequest} from 'supporter';

@Component({
  metaInfo() {
    return {title: this.showTitle};
  },
  components: {CompSelectBox, SummerNote}
})
export default class PopupContract extends Vue {
  // init Flg
  private initOver = false;
  // query
  private mallNo = 0;
  private contractNo = '';
  private division = '';

  // title
  private get showTitle() {
    let showTitle = '';
    switch (this.division) {
      case 'standard':
        showTitle = this.$t('CONTRACT_POPUP_STANDARD_TITLE') as string;
        break;
      case 'normal':
        showTitle = this.$t('CONTRACT_POPUP_NORMAL_TITLE') as string;
        break;
      case 'register':
        showTitle = this.$t('CONTRACT_POPUP_REGISTER_TITLE') as string;
        break;
      case 'registerCancel':
        showTitle = this.$t('CONTRACT_POPUP_REGISTER_CANCEL_TITLE') as string;
        break;
      case 'history':
        showTitle = this.$t('CONTRACT_POPUP_HISTORY_TITLE') as string;
        break;
      case 'modification':
        showTitle = this.$t('CONTRACT_POPUP_MODIFICATION_TITLE') as string;
        break;
      case 'cancel':
        showTitle = this.$t('CONTRACT_POPUP_CANCEL_TITLE') as string;
        break;
    }
    return showTitle;
  }

  // 계약내용 변경일
  private registerYmdt: string = '';

  // 동의일
  private agreedDateTime = '';
  private agreedDates = [];
  private contracts = [];
  private changeAgreedDate() {
    this.contracts.forEach((item) => {
      if (item.agreedDateTime === this.agreedDateTime) {
        if (item.contents) this.initContent = item.contents;
        if (item.changeReason && item.changeReason !== '') {
          this.changeReason = item.changeReason;
          this.disableReason = true;
        } else {
          this.disableReason = false;
        }
      }
    });
  }

  // 내용
  private initContent: string = '';
  private content: string = '';
  private summerNoteOptions = {
    height: 300,
    imageFileSize: 1024 * 5,
    disableDragAndDrop: true,
    disableImageUpload: true
  };
  private get summerNoteDisable() {
    let flg = false;
    if (this.division === 'history' || this.division === 'cancel' || this.division === 'registerCancel') {
      flg = true;
    }
    return flg;
  }
  private editorOnChange({html}: {html: string}) {
    this.content = html;
  }

  // 변경 사유
  private changeReason = '';
  private disableReason = false;

  // save
  private get btnLabel() {
    let label = '';
    switch (this.division) {
      case 'modification':
        label = this.$t('CONTRACT_POPUP_MODIFICATION_BTN') as string;
        break;
      case 'cancel':
        label = this.$t('CONTRACT_POPUP_CANCEL_BTN') as string;
        break;
      case 'register':
        label = this.$t('CONTRACT_POPUP_REGISTER_BTN') as string;
        break;
      case 'registerCancel':
        label = this.$t('CONTRACT_POPUP_REGISTER_CANCEL_BTN') as string;
        break;
      default:
        label = this.$t('COMMON_SAVE') as string;
        break;
    }

    return label;
  }
  private async save() {
    if (!this.isFormPassed()) {
      return;
    }

    switch (this.division) {
      case 'register':
      case 'modification':
        let modificationRequest: PostContractsEntryContractsRequest = {
          pathParams: {
            contractNo: this.contractNo
          },
          data: {
            contractContents: this.content
          }
        };
        if (this.division === 'modification') {
          modificationRequest.data.changeReason = this.changeReason;
        }
        await this.$api.postContractsEntryContracts(modificationRequest);
        break;
      case 'cancel':
      case 'registerCancel':
        await this.$api.deleteContractsEntryContracts({pathParams: {contractNo: this.contractNo}});
        break;
    }
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}(${JSON.stringify(this.content)});`);
    }
    if (this.division === 'normal' || this.division === 'standard') {
      alert(this.$t('CONTRACT_POPUP_SUCCESS_MSG'));
    }
    window.close();
  }
  private isFormPassed() {
    if (this.division === 'normal' || this.division === 'standard') {
      if (this.content === '') {
        alert(this.$t('CONTRACT_POPUP_ERR_CONTENT_NULL'));
        (this.$refs.content as any).focus();
        return false;
      }

      return true;
    }

    if (this.division === 'register') {
      if (!confirm(this.$t('CONTRACT_POPUP_REGISTER_CONFIRM') as string)) {
        return false;
      }
      if (this.content === '') {
        alert(this.$t('CONTRACT_POPUP_ERR_CONTENT_NULL'));
        (this.$refs.content as any).focus();
        return false;
      }

      return true;
    }
    if (this.division === 'modification') {
      if (!confirm(this.$t('CONTRACT_POPUP_MODIFICATION_CONFIRM') as string)) {
        return false;
      }
      if (this.content === '') {
        alert(this.$t('CONTRACT_POPUP_ERR_CONTENT_NULL'));
        (this.$refs.content as any).focus();
        return false;
      }
      if (this.changeReason === '') {
        alert(this.$t('CONTRACT_POPUP_ERR_CHANGE_REASON_NULL'));
        (this.$refs.changeReason as any).focus();
        return false;
      }

      return true;
    }

    if (this.division === 'cancel') {
      return confirm(this.$t('CONTRACT_POPUP_CANCEL_CONFIRM') as string);
    }

    if (this.division === 'registerCancel') {
      return confirm(this.$t('CONTRACT_POPUP_REGISTER_CANCEL_CONFIRM') as string);
    }

    return true;
  }

  // close
  private close() {
    window.close();
  }

  private async created() {
    if (this.$route.query) {
      this.mallNo = Number(this.$route.query.mallNo) || Number(this.$route.query.mallPartnerContractNo);
      this.division = this.$route.query.type as string;
      if (this.$route.query.updateYn === 'true') {
        this.initContent = sessionStorage.getItem('contractContent');
        this.content = this.initContent;
      }
      this.contractNo = this.$route.query.contractNo as string;
      if (this.division === 'registerCancel' || this.division === 'modification' || this.division === 'history' || this.division === 'cancel') {
        let request = {
          pathParams: {
            contractNo: this.contractNo
          }
        };
	      
        let {data} = await this.$api.getContractsEntryContracts(request);
        if (data.length > 0) {
          this.contracts = await data.sort((itemA, itemB) => {
            return itemA.agreedDateTime > itemB.agreedDateTime ? -1 : 1;
          });

          this.initContent = this.contracts[0].contents ?? ''

          if (this.division === 'registerCancel' || this.division === 'cancel') {
            this.registerYmdt = changeDateFormat(this.contracts[0].createdDateTime, 'YYYY년 MM월 DD일');
          }

          if (this.division === 'history') {
            this.contracts = this.contracts.filter(item => item.agreed);
          }
          
          if (this.division === 'history') {
            this.agreedDateTime = this.contracts[0].agreedDateTime;
            this.agreedDates = this.contracts.map((item) => {
              return {
                value: item.agreedDateTime,
                name: changeDateFormat(item.agreedDateTime, 'YYYY년 MM월 DD일 | HH:mm:ss')
              };
            });
            this.changeAgreedDate();
          }

          if (this.division === 'cancel') {
            let tempContent = data.find((item) => !item.agreed);
            if (tempContent) {
              this.initContent = tempContent.contents;
              if (tempContent.changeReason && tempContent.changeReason !== '') {
                this.changeReason = tempContent.changeReason;
                this.disableReason = true;
              } else {
                this.disableReason = false;
              }
            }
          }
        }
      } else if (this.division === 'standard') {
        this.summerNoteOptions['toolbar'] = [
          ['fontsize', ['fontsize']],
          ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
          ['color', ['color']],
          ['para', ['paragraph']],
          ['height', ['height']],
          ['misc', ['codeview']]
        ];
      }
    }
    this.initOver = true;
  }

  private async mounted() {
    this.$nextTick(() => {
      if (this.division === 'registerCancel') {
        popupResize(997, 717);
      } else if (this.division === 'modification') {
        popupResize(997, 750);
      } else if (this.division === 'history') {
        popupResize(986, 711);
      } else if (this.division === 'cancel') {
        popupResize(997, 790);
      } else {
        popupResize(1014, 670);
      }
    });
  }
}
